import { clinicalApiPath, viperApi } from '@/services/viper-api'

export class OrganizationTrialStatusService {
  /**
   * Constructs OrganizationTrialStatusService
   * @param api {AxiosInstance}
   * @param basePath {String}
   */
  constructor(api, basePath) {
    this.api = api
    this.basePath = basePath
  }

  /**
   * Creates OrganizationTrialStatus
   * @param request { organizationTrialId, value }
   * @returns {*}
   */
  create(request) {
    return viperApi.post(`${this.basePath}/organization-trial-status`, request)
  }
}

export default new OrganizationTrialStatusService(viperApi, clinicalApiPath)
